/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import {
  TRANSACTION_RENTAL,
  TRANSACTION_SALE,
  TRANSACTION_SEASONAL_RENTAL
} from '../../enums/TransactionCodes.mjs'

export type TransactionLabelProps = {
  value: TransactionType
}

function TransactionLabel (props: TransactionLabelProps) {
  const { value } = props
  const intl = useIntl()

  if (value === TRANSACTION_RENTAL) {
    return intl.formatMessage({
      id: 'rental',
      defaultMessage: 'Location'
    })
  }
  if (value === TRANSACTION_SEASONAL_RENTAL) {
    return intl.formatMessage({
      id: 'seasonal_rental',
      defaultMessage: 'Location saisonnière'
    })
  }
  if (value === TRANSACTION_SALE) {
    return intl.formatMessage({
      id: 'sale',
      defaultMessage: 'Vente'
    })
  }
  return null
}

export default TransactionLabel
